// Base API URL comes from the environment — never hardcoded per environment.
//   Priority:
//   1. REACT_APP_API_BASE_URL injected at build time (CI/CD) or via .env files
//        - `npm start`     -> .env.development  (http://localhost:5001)
//        - `npm run build` -> CI/CD-injected value, then .env.production
//   2. Fallback in code below (dev -> localhost:5001, prod -> same-origin "")
// The value must NOT include a trailing /api — endpoints below append it.
const server =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001');

const Api = {
  // Base
  main: server,

  // Health....
  health: server + '/api/health',

  // Authhhhh
  authRegister: server + '/api/auth/register',
  authLogin: server + '/api/auth/login',
   authLoginEmailOtp: server + '/api/auth/login-email-otp',
  authRefreshToken: server + '/api/auth/refresh-token',
  authVerifyPhone: server + '/api/auth/verify-phone',
  authResendOtp: server + '/api/auth/resend-otp',
  authSendEmailOtp: server + '/api/auth/email-otp/send',
  authVerifyRegisterOtp: server + '/api/auth/email-otp/verify-register',
  authForgotPassword: server + '/api/auth/forgot-password',
  authResetPassword: server + '/api/auth/reset-password',
  authSocialConfig: server + '/api/auth/social-config',
  authGoogle: server + '/api/auth/google',
  authGoogleExchange: server + '/api/auth/google/exchange',

  // ATOZAS Cross-Domain SSO (mounted at /auth, NOT /api)
  atozasLogin: server + '/auth/atozas',            // GET (full-page redirect to IdP)
  atozasMe: server + '/auth/atozas/me',            // GET (restore JWT from ATOZAS session)
  atozasLogout: server + '/auth/logout',           // POST (destroy ATOZAS session)

  // Users
  userProfile: server + '/api/users/profile',               // GET/PUT
  userUpdateRoles: server + '/api/users/roles',             // PUT
  userReviews: server + '/api/users/reviews',               // GET
  userDeactivate: server + '/api/users/deactivate',         // PUT
  userWorkAddresses: server + '/api/users/work-addresses',  // POST/PUT, DELETE add /:addressId
  userCompleteBasicProfile: server + '/api/users/complete-basic-profile',   // PUT
  userCompleteWorkerProfile: server + '/api/users/complete-worker-profile', // PUT

  // Utility
  pincodeLookup: server + '/api/utils/pincode',

  // Workers
  workerProfile: server + '/api/workers/profile',           // GET/POST/PUT
  workerSearch: server + '/api/workers/search',             // GET
  workerVillages: server + '/api/workers/villages',         // GET
  workerSkills: server + '/api/workers/skills',             // GET (legacy; prefer skills for dropdown)
  skills: server + '/api/skills',                          // GET list, POST add new (master list for dropdowns)
  workerNames: server + '/api/workers/names',               // GET
  workerById: server + '/api/workers',                      // GET add /:workerId
  workerAvailability: server + '/api/workers/availability', // PUT
  workerBlackout: server + '/api/workers/blackout',         // POST
  workerStatus: server + '/api/workers/status',             // PUT
  workerStatsDashboard: server + '/api/workers/stats/dashboard', // GET
  workerScheduleUnavailable: server + '/api/workers/schedule/unavailable', // GET/PUT

  // Worker Identity Card (QR-based digital ID)
  workerIdentityCard: server + '/api/workers/identity-card',  // GET (own card)
  workerVerifyPublic: server + '/api/workers/verify',         // GET add /:workerId (public)

  // KYC (worker identity verification)
  kycStatus: server + '/api/kyc/status',
  kycAadhaarInit: server + '/api/kyc/aadhaar/init',
  kycAadhaarVerify: server + '/api/kyc/aadhaar/verify',
  kycAadhaarConfirm: server + '/api/kyc/aadhaar/confirm',

  // Bookings
  bookingRequest: server + '/api/bookings/request',         // POST
  bookingCheckConflict: server + '/api/availability/check', // GET - check for conflicts
  bookingRespond: server + '/api/bookings',                 // PUT add /:bookingId/respond
  bookingConfirm: server + '/api/bookings',                 // PUT add /:bookingId/confirm
  bookingScheduleUpdate: server + '/api/bookings',          // PUT add /:bookingId/schedule
  bookingScheduleRespond: server + '/api/bookings',         // PUT add /:bookingId/schedule/respond
  myBookings: server + '/api/bookings/my-bookings',         // GET
  workerBookings: server + '/api/bookings/worker',          // GET add /:workerId
  bookingById: server + '/api/bookings',                    // GET add /:bookingId
  bookingStatus: server + '/api/bookings',                  // PUT add /:bookingId/status
  bookingPayment: server + '/api/bookings',                 // PUT add /:bookingId/payment
  bookingMessages: server + '/api/bookings',                // POST add /:bookingId/messages
  bookingWorkProgress: server + '/api/bookings',            // PUT add /:bookingId/work-progress
  bookingWorkProgressConsent: server + '/api/bookings',     // PUT add /:bookingId/work-progress/consent
  bookingReview: server + '/api/bookings',                  // POST add /:bookingId/review
  bookingVerifyWorker: server + '/api/bookings',            // POST add /:bookingId/verify-worker
  bookingsWeeklySummary: server + '/api/bookings/weekly-summary', // GET ?role=worker|owner&referenceDate=YYYY-MM-DD
  bookingsDashboardStats: server + '/api/bookings/dashboard-stats', // GET ?referenceDate=YYYY-MM-DD

  // Job Requests
  jobRequests: server + '/api/job-requests',                // GET (list) / POST (create)
  jobRequestById: server + '/api/job-requests',             // GET add /:jobRequestId
  myJobRequestsPosted: server + '/api/job-requests/my/posted', // GET
  jobRequestApply: server + '/api/job-requests',            // POST add /:jobRequestId/apply
  jobRequestApplications: server + '/api/job-requests',     // PUT add /:jobRequestId/applications/:applicationId
  jobRequestStatus: server + '/api/job-requests',           // PUT add /:jobRequestId/status
  jobRequestEdit: server + '/api/job-requests',            // PUT add /:jobRequestId/edit
  jobRequestPostpone: server + '/api/job-requests',        // PUT add /:jobRequestId/postpone
  jobRequestApplicationRespond: server + '/api/job-requests', // PUT add /:jobRequestId/applications/:applicationId/respond

  // Notifications
  notifications: server + '/api/notifications',             // GET
  notificationRead: server + '/api/notifications',          // PUT add /:notificationId/read
  notificationsReadAll: server + '/api/notifications/read-all', // PUT
  notificationById: server + '/api/notifications',          // DELETE add /:notificationId
  notificationsDeleteAll: server + '/api/notifications',    // DELETE (delete all)

  // Legal documents
  legalPrivacyPolicy: server + '/api/legal/privacy_policy',           // GET
  legalTermsAndConditions: server + '/api/legal/terms_and_conditions', // GET

  // Testimonials
  testimonials: server + '/api/testimonials',               // GET/POST

  myTestimonial: server + '/api/testimonials/my-testimonial', // GET

  // Home - Popular/Featured Services
  featuredServices: server + '/api/featured-services',

  // Home - Most Popular Services (circle avatar section)
  popularServices: server + '/api/popular-services',

  // Home - Public assets (banners/images)
  homeAssets: server + '/api/home-assets',

  // Feedback
  feedback: server + '/api/feedback',

  // Push Notifications
  pushVapidPublicKey: server + '/api/push-notifications/vapid-public-key', // GET
  pushSubscribe: server + '/api/push-notifications/subscribe',             // POST
  pushUnsubscribe: server + '/api/push-notifications/unsubscribe',         // POST
  pushSubscriptions: server + '/api/push-notifications/subscriptions',      // GET
  pushStatus: server + '/api/push-notifications/status',                   // GET

  // Chatbot
  chatbotChat: server + '/api/chatbot/chat',

  // Visitor analytics (anonymous device/usage tracking)
  visitorTrack: server + '/api/visitors/track',
};

export default Api;